import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CellRenderer, CellRendererParams } from 'app/shared/components/smart-grid/core/interfaces/cell-renderer.interface';

/**
 * Return Type Cell Renderer Component
 *
 * Displays return type code and name.
 * Shows code in bold followed by type name.
 *
 * @example
 * ```typescript
 * {
 *   field: 'returnType',
 *   headerName: 'Motivo de Devolución',
 *   cellRenderer: ReturnTypeCellRendererComponent,
 *   minWidth: 200
 * }
 * ```
 */
@Component({
  selector: 'app-return-type-cell-renderer',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="text-content">
      <b>{{ returnTypeCode }}</b>
      <ng-container *ngIf="returnTypeName"> - {{ returnTypeName }}</ng-container>
    </div>
  `,
  styles: [`
    :host {
      display: block;
      width: 100%;
    }
    .text-content {
      white-space: normal;
      line-height: 1.4;
    }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReturnTypeCellRendererComponent implements CellRenderer<any> {
  @Input() params!: CellRendererParams<any>;

  /**
   * Get return type code
   */
  get returnTypeCode(): string {
    return this.params?.data?.returnType?.code ?? '-';
  }

  /**
   * Get return type name
   */
  get returnTypeName(): string {
    return this.params?.data?.returnType?.name ?? '';
  }
}
